import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	delete: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	delete: {
		id: 'project-directories.versions.delete-version.footer.delete',
		defaultMessage: 'Delete',
		description: '',
	},
	cancel: {
		id: 'project-directories.versions.delete-version.footer.cancel',
		defaultMessage: 'Cancel',
		description: '',
	},
});
export default messages;
